import { TColorTheme } from "./colorTheme.t";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { COLOR_THEME_NAMES } from "./colorTheme.constants";

export const LOCAL_STORAGE_USER_THEME_KEY = 'user_color_theme_key';
export const LOCAL_STORAGE_APP_THEME_KEY = 'app_color_theme_key';

export interface IColorThemeState {
    userTheme: TColorTheme;
    appTheme: Extract<TColorTheme, 'light' | 'dark'>;
}

const initialState: IColorThemeState = {
    userTheme: localStorage.getItem(LOCAL_STORAGE_USER_THEME_KEY) as TColorTheme || COLOR_THEME_NAMES.DARK,
    appTheme: localStorage.getItem(LOCAL_STORAGE_APP_THEME_KEY) as IColorThemeState['appTheme'] || COLOR_THEME_NAMES.DARK,
};

export const colorThemeSlice = createSlice({
    name: 'colorTheme',
    initialState,
    reducers: {
        setUserThemeAction(state, action: PayloadAction<TColorTheme>) {
            state.userTheme = action.payload;
        },
        setAppThemeAction(state, action: PayloadAction<IColorThemeState['appTheme']>) {
            state.appTheme = action.payload;
        },
    },
});

export default colorThemeSlice.reducer;